import { ReactNode } from "react"
import { ChevronRightIcon } from '@heroicons/react/20/solid'

import { Link } from "../navigation"

/** Breadcrumb header for IP Management sub-pages: "IP Management > <label>". */
export default function IpManagementBreadcrumbs({ label }: { label: ReactNode }) {
    return (
        <h2 className="flex flex-row gap-1 md:gap-4 whitespace-nowrap shrink min-w-0 grow pr-4">
            <Link to="/management/cockpit" className="modern-h2">IP Management</Link>
            <ChevronRightIcon className="h-5 w-5 flex-shrink-0 text-gray-600 self-center" aria-hidden="true" />
            <span className="modern-h2">{label}</span>
        </h2>
    )
}
